module.exports = __webpack_public_path__ + "static/img/admin_headimg_schooldoctor.b6b2c1bd.png";